<template>

</template>

<script>
    export default {
        methods: {
            removePopupsHandler() {
                var popUps = document.getElementsByClassName('mapboxgl-popup');
                if(!popUps.length) return;
                [...popUps].forEach(popup => popup.remove())
            }
        }
    }
</script>